import { render, staticRenderFns } from "./ClipartSelector.vue?vue&type=template&id=6bb53671&scoped=true"
import script from "./ClipartSelector.vue?vue&type=script&lang=js"
export * from "./ClipartSelector.vue?vue&type=script&lang=js"
import style0 from "./ClipartSelector.vue?vue&type=style&index=0&id=6bb53671&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb53671",
  null
  
)

export default component.exports